import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Mail } from "lucide-react";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/leads").then((r) => setLeads(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary" /></div>;

  return (
    <div>
      <h1 className="font-heading font-black text-3xl tracking-tight">Leads</h1>
      <p className="text-muted-foreground mt-2">{leads.length} email captures.</p>

      {leads.length === 0 ? (
        <div className="bg-white border border-border p-10 text-center mt-8">
          <Mail className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No leads yet.</p>
        </div>
      ) : (
        <div className="bg-white border border-border mt-8 divide-y divide-border">
          {leads.map((l) => (
            <div key={l.id} data-testid={`admin-lead-${l.id}`} className="flex items-center justify-between p-4">
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary" />
                <span className="font-medium">{l.email}</span>
              </div>
              <div className="text-sm text-muted-foreground">
                <span className="mr-4 font-mono text-xs bg-secondary px-2 py-1">{l.source}</span>
                {new Date(l.created_at).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
